// import React, { useEffect, useRef, useState } from "react";
// import about from "../Images/About.jpeg";
// import { useNavigate } from "react-router-dom";

// const AboutUs = () => {
//   const navigate = useNavigate();
//   const [count, setCount] = useState(0);
//   const started = useRef(false);

//   useEffect(() => {
//     if (started.current) return;
//     started.current = true;

//     const end = 15;
//     const duration = 1500;
//     const startTime = performance.now();

//     const animate = (currentTime) => {
//       const progress = Math.min((currentTime - startTime) / duration, 1);
//       setCount(Math.floor(progress * end));
//       if (progress < 1) requestAnimationFrame(animate);
//     };

//     requestAnimationFrame(animate);
//   }, []);

//   return (
//     <section className="about-section py-5">
//       <div className="container">
//         <div className="row align-items-center">

//           {/* LEFT IMAGE */}
//           <div className="col-lg-6 mb-5 mb-lg-0">
//             <div className="about-image-wrap">

//               <div className="about-top-counter text-white text-center">
//                 <h2 className="mb-1">{count}+</h2>
//                 <p className="mb-0">
//                   Years Experience <br /> In Industrial Supplies
//                 </p>
//               </div>

//               <img
//                 src={about}
//                 className="about-img"
//                 alt="About Baba Industries"
//                 style={{ height: "530px", objectFit: "cover" }}
//               />
//             </div>
//           </div>

//           {/* RIGHT CONTENT */}
//           <div className="col-lg-6 ps-lg-5">
//             <div className="about-right">

//               <div className="about-badge">
//                 <span>ABOUT US</span>
//               </div>

//               <h2 className="about-title">
//                 Supplying Quality Pipes, Motors & Cables You Can Trust
//               </h2>

//               <p className="about-desc">
//                 We are a trusted supplier of premium quality pipes, motors, and electrical
//                 cables, serving industrial, commercial, and residential projects. Our
//                 products are known for durability, efficiency, and long-lasting performance.
//               </p>

//               <div className="about-actions">
//                 <button
//                   className="btn-read"
//                   onClick={() => navigate("/about")}
//                 >
//                   READ MORE <span>↗</span>
//                 </button>
//               </div>

//               <div className="about-services">
//                 <div className="service-box">
//                   {/* <div className="service-icon">🧱</div> */}
//                   <h5>Pipe Supply</h5>
//                   <p>High-quality pipes for industrial and construction use.</p>
//                 </div>

//                 <div className="service-box">
//                   {/* <div className="service-icon">⚙️</div> */}
//                   <h5>Motors & Cables</h5>
//                   <p>Reliable motors and electrical cables for all applications.</p>
//                 </div>
//               </div>

//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutUs;





















































import React, { useEffect, useRef, useState } from "react";
import about from "../Images/About.jpeg";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const end = 15;
    const duration = 1500;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, []);

  return (
   <>

    <section className="py-5">
      <div className="container">

        {/* ROW – stretch for equal height */}
        <div className="row align-items-stretch">

          {/* LEFT IMAGE */}
          <div className="col-lg-6 mb-4 mb-lg-0 d-flex">
            <div
              className="w-100 position-relative"
              style={{
                height: "420px",         
                borderRadius: "16px",
                overflow: "hidden",
              }}
            >
              {/* COUNTER BOX */}
              <div
                className="position-absolute text-white text-center"
                style={{
                  top: "20px",
                  left: "20px",
                  background: "#0d6efd",
                  padding: "15px 20px",
                  borderRadius: "12px",
                  zIndex: 2,
                }}
              >
                <h2 className="mb-1">{count}+</h2>
                <p className="mb-0">
                  Years Experience <br /> In Industrial Supplies
                </p>
              </div>

              {/* IMAGE */}
              <img
                src={about}
                alt="About Baba Industries"
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6 ps-lg-5 d-flex">
            <div className="d-flex flex-column justify-content-between w-100">

              <div>
                <span className="fw-bold text-primary">ABOUT US</span>

                <h2 className="fw-bold mt-3">
                  Supplying Quality Pipes, Motors & Cables You Can Trust
                </h2>

                <p className="mt-3 text-muted">
                  We are a trusted supplier of premium quality pipes, motors, and
                  electrical cables, serving industrial, commercial, and residential
                  projects. Our products are known for durability, efficiency, and
                  long-lasting performance.
                </p>

                <button
                  className="btn btn-primary rounded-pill px-4 mt-3"
                  onClick={() => navigate("/about")}
                >
                  READ MORE ↗
                </button>
              </div>

              {/* SERVICE BOXES */}
              <div className="row mt-4">
                <div className="col-md-6 mb-3">
                  <div className="p-4 bg-light rounded h-100">
                    <h5>Pipe Supply</h5>
                    <p className="mb-0">
                      High-quality pipes for industrial and construction use.
                    </p>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="p-4 bg-light rounded h-100">
                    <h5>Motors & Cables</h5>
                    <p className="mb-0">
                      Reliable motors and electrical cables for all applications.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>

    </>
  );
};

export default AboutUs;
